import { render, staticRenderFns } from "./grantTable.vue?vue&type=template&id=5d7a33dc&scoped=true"
import script from "./grantTable.vue?vue&type=script&lang=js"
export * from "./grantTable.vue?vue&type=script&lang=js"
import style0 from "./grantTable.vue?vue&type=style&index=0&id=5d7a33dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a33dc",
  null
  
)

export default component.exports